import {
  deleteAdminV1StoresStoreIdApiKeysId,
  getAdminV1StoresStoreIdApiKeys,
  patchAdminV1StoresStoreIdApiKeysId,
  postAdminV1StoresStoreIdApiKeys,
  postAdminV1StoresStoreIdApiKeysIdRevoke,
  type ApiKey,
  type CreateApiKeyRequest,
  type CreateApiKeyResponse,
  type UpdateApiKeyRequest,
} from '@nucleus-commerce/api-client/admin';

/** Storefront API keys of one store: a bounded `{ items }` list, newest first. */
export const apiKeysApi = {
  list: (storeId: string): Promise<ApiKey[]> =>
    getAdminV1StoresStoreIdApiKeys({ storeId }).then((r) => r.items),
  create: (storeId: string, body: CreateApiKeyRequest): Promise<CreateApiKeyResponse> =>
    postAdminV1StoresStoreIdApiKeys({ storeId }, body),
  /** 409 on a revoked key; the key value itself never changes. */
  update: (storeId: string, id: string, body: UpdateApiKeyRequest): Promise<ApiKey> =>
    patchAdminV1StoresStoreIdApiKeysId({ storeId, id }, body),
  revoke: (storeId: string, id: string): Promise<ApiKey> =>
    postAdminV1StoresStoreIdApiKeysIdRevoke({ storeId, id }),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdApiKeysId({ storeId, id }),
};
